import React from 'react';

import { components, MenuListProps, GroupBase } from 'react-select';

import { TSelectOptionsType } from 'domains/ReportBuilder/types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import css from '../styles.module.scss';

type TMenuListProps = MenuListProps<
  TSelectOptionsType,
  true,
  GroupBase<TSelectOptionsType>
>;

const MenuList = (props: TMenuListProps): JSX.Element => {
  const { t } = useTranslation();
  const { children, selectProps, getValue } = props;

  const selectedOptions = getValue();
  console.log(selectedOptions,'selectedOptions');
  
  // Все исходные опции, а не только отфильтрованные поиском
  const allOptions = selectProps.options as TSelectOptionsType[];

  const isAllSelected =
    allOptions.length > 0 &&
    allOptions.every((option) =>
      selectedOptions.some((selected) => selected.value === option.value),
    );

  const handleSelectAll = (): void => {
    if (isAllSelected) {
      selectProps.onChange([], {
        action: 'clear',
        removedValues: selectedOptions,
      });
    } else {
      selectProps.onChange(allOptions, {
        action: 'select-option',
        option: allOptions[0],
      });
    }
  };

  return (
    <components.MenuList {...props}>
      <div
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
        className={css.menulist}
        onClick={handleSelectAll}
      >
        <div className={css.menuLeft}>
          <div
            className={cn(css.checkbox, {
              _isChecked: isAllSelected,
              _isPartly: !isAllSelected && !!selectedOptions.length,
            })}
          />
          <button type="button">{t(`select_all`)}</button>
        </div>
        <div
          className={cn(css.selectedValue, {
            isAllSelected,
          })}
        >
          {allOptions.length}
        </div>
      </div>

      {children}
    </components.MenuList>
  );
};

export default MenuList;
